import React, { ReactNode } from 'react';

import { Picto } from '../../components/Picto';
import { Faq } from '../../layouts/Faq';
import { textTitle3 } from '../../styles/typography';
import { fontHeading2 } from '../../styles/typographyNew';
import { PayFitColor } from '../../types/module';
import { classNames } from '../../utils/style';
import { applyBgColor } from '../../utils/utils';

export interface QuestionAnswerProps {
  question: string;
  answer: ReactNode | string;
  onClick?: any;
}

export interface FaqSectionProps {
  title?: string;
  subtitle?: string;
  icon?: any;
  ctaButton?: ReactNode;
  body: QuestionAnswerProps[];
  isTransparent?: boolean;
  backgroundColor?: PayFitColor;
  isDark?: boolean;
  className?: string;
}

export const FaqSection = ({
  title,
  subtitle,
  icon,
  ctaButton,
  body,
  backgroundColor = 'white',
  isTransparent = false,
  isDark = false,
  className,
}: FaqSectionProps) => {
  return (
    <div
      className={classNames(
        'FAQ',
        className,
        applyBgColor(backgroundColor, isDark),
      )}
      id={title?.replace(/\W+/g, '-')}
    >
      <div
        className={classNames(
          'mx-0 px-16 sm:max-w-719',
          'md:px-0 md:mx-auto md:max-w-736',
          'lg:max-w-1000 xl:max-w-[1202px]',
          'w-full flex flex-col items-center',
        )}
      >
        {(title || subtitle) && !icon && (
          <div className="self-start lg:w-6/8 xl:w-6/12">
            {title && (
              <h2
                className={classNames(
                  isDark ? 'text-neutral-1' : 'text-neutral-301',
                  'font-medium',
                  subtitle ? 'pb-24' : 'pb-40 md:pb-64',
                  fontHeading2,
                )}
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p
                className={classNames(
                  isDark ? 'text-neutral-1' : 'text-neutral-101',
                  'pb-40 md:pb-64',
                  textTitle3,
                )}
              >
                {subtitle}
              </p>
            )}
          </div>
        )}
        {title && icon && (
          <div className="flex flex-col items-center mb-40 text-center lg:w-6/8 xl:w-6/12 md:mb-48">
            <Picto name={icon} className={`mb-24`} />
            <h2
              className={classNames(
                isDark ? 'text-neutral-1' : 'text-neutral-301',
                'pb-24',
                fontHeading2,
              )}
            >
              {title}
            </h2>
            {ctaButton && ctaButton}
          </div>
        )}

        <Faq
          body={body}
          className={classNames(
            isTransparent
              ? applyBgColor(backgroundColor, isDark)
              : 'bg-transparent',
          )}
        />
      </div>
    </div>
  );
};
